import { render, staticRenderFns } from "./SavedContent.vue?vue&type=template&id=01a63ebc&scoped=true&"
import script from "./SavedContent.vue?vue&type=script&lang=js&"
export * from "./SavedContent.vue?vue&type=script&lang=js&"
import style0 from "./SavedContent.vue?vue&type=style&index=0&id=01a63ebc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a63ebc",
  null
  
)

export default component.exports